import { PensionPlanTransfer } from '../../api/pension-plan-transfers/interfaces/PensionPlanTransfer';

const PREFIJO = 'arca_resumen_plan_visto_';

/**
 * Que la persona ha entrado a este plan, y cuándo. Lo apunta el Dashboard al enseñar el plan.
 *
 * En `localStorage`, como el «visto» de Inicio (`transferConfirmationSeen`): no hay backend que
 * lo recuerde. No vale esa marca: Inicio marca de una vez todos los traspasos completados de la
 * persona, y aquí cada card espera a que se entre a SU plan.
 */
export function marcarPlanVisto(planId: string, ahora: Date = new Date()): void {
	try {
		localStorage.setItem(PREFIJO + planId, ahora.toISOString());
	} catch {
		// Sin persistencia no hay nada que recordar: al leer, se trata como «no se ve».
	}
}

/**
 * Si la card de `planId` enseña este traspaso completado (Elena): hasta que se entra a su plan,
 * y solo si se completó después de la última vez que se entró. No caduca: se queda hasta que se
 * entra (Marisa, 19/10/2026).
 *
 * 🔴 Si no se puede leer, no se enseña: es un aviso puntual, y repetirlo para siempre es peor que
 * perdérselo (mismo criterio que `TarjetaTraspaso`).
 */
export function completadoPorVer(transfer: PensionPlanTransfer, planId: string): boolean {
	if (transfer.status !== 'completed') return false;
	// Cuándo pasó a completado en Arca, no cuándo lo ejecutó Caser (`executedAt`, que puede ser
	// anterior a una visita hecha con el traspaso aún en curso). `completed` es final, así que su
	// última actualización es ese momento.
	const completadoEl = new Date(transfer.updatedAt).getTime();
	try {
		const visto = localStorage.getItem(PREFIJO + planId);
		return !visto || new Date(visto).getTime() < completadoEl;
	} catch {
		return false;
	}
}
